import { render, staticRenderFns } from "./MainTemp.vue?vue&type=template&id=b7215366&scoped=true"
import script from "./MainTemp.vue?vue&type=script&lang=js"
export * from "./MainTemp.vue?vue&type=script&lang=js"
import style0 from "./MainTemp.vue?vue&type=style&index=0&id=b7215366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7215366",
  null
  
)

export default component.exports